import React from "react";
import TextConfirmation from "./TextConfirmation";
import ModalButtons from '../ModalButtons/ModalButtons';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";



export default class ModalDeleteConfirmation extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading: false,
      textConfirmation: false,
      doubleTextConfirmation:false,
    };
    this.onTextConfirmation = this.onTextConfirmation.bind(this);
    this.onDoubleTextConfirmation = this.onDoubleTextConfirmation.bind(this);
  };

  // Render Functions  //

  render(){
    return (
      <div> 
        <ModalButtons loading={this.state.loading} buttons={this.setButtons()} />
        {this.renderModalBody()}
      </div>
    );
  };

  renderModalBody() {
    return (
      <div className="modal-body">
        <div className="alert alert-warning" style={{ marginBottom: 0 }} role="alert">
          <b className="alert-heading" style={{ marginBottom: "15px"}}>
            {this.props.records.length > 1 ? I18n.t("are_you_sure_you_want_to_delete_these_records") : I18n.t("are_you_sure_you_want_to_delete_this_record")}
          </b>
          <TextConfirmation onTextConfirmation={this.onTextConfirmation} showDoubleConfirmation={this.props.showDoubleConfirmation} onDoubleTextConfirmation={this.onDoubleTextConfirmation} environment={this.props.environment}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  setButtons(){
    return [
      {
        name: I18n.t('cancel'),   
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary', this.state.textConfirmation == true && this.state.doubleTextConfirmation == true ? null : ' disabled'],
        onClick: (e) => {
          this.submit()
          return false;
        },
      },
      
    ];
    
  };

  // Change Handlers //

  onTextConfirmation(textConfirmation) {
    this.setState({ textConfirmation: textConfirmation });
  }

  onDoubleTextConfirmation(doubleConfirmation) {
    this.setState({ doubleTextConfirmation: doubleConfirmation });

  }
  
  // AJAX Calls // 

  submit() {
    this.setState({ loading: true });
    
    $.ajax({
      type: "POST",
      url: this.props.delete_path,
      data: {
        record_ids: this.props.records,
      },
    }).done((data) => {
      this.setState({ loading: false });
      if (parent && parent.refresh_data) {
      
        parent.refresh_data(I18n.t("record_deleted_successfully"));
        
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
      
    });
  }

}